import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { RESOLVER_TYPE_SUBCATEGORY } from '../../services/resolver/types'
import { connect as connectLanguage } from '../Language/connect'
import { getBoundActions } from '../../actions/index'
import JumbotronSubcategory from '../JumbotronSubcategory/index'
import BannerPlaceholder from '../BannerPlaceholder/index'
import {
  TYPE_CONTENT_SUBCATEGORY,
} from '../../services/content-type/index'
import { isSynced as resolverIsSynced } from '../../services/resolver/synced'

function createOnLanguageChange (actions) {
  return actions.jumbotron.resetJumbotronData
}

function jumbotronIsSynced (jumbotron, resolver) {
  const resolvedId = resolver.getIn(['data', 'id'])
  return (
    resolvedId === jumbotron.get('id')
    && resolvedId === jumbotron.getIn(['data', 'id'])
  )
}

function updateData (props) {
  const {
    storeKey, resolver, jumbotron, auth, location, user,
  } = props
  const {
    setJumbotronDataPlaceholder,
    getJumbotronData,
    getJumbotronDataUserInfo,
    setCommentsVisible,
  } = props
  const resolvedId = resolver.getIn(['data', 'id'])
  const jumbotronState = jumbotron.get(storeKey, Map())
  const jumbotronData = jumbotronState.get('data', Map())
  const jumbotronSynced = jumbotronIsSynced(jumbotronState, resolver)
  const userInfoSynced = !!jumbotronData.get('userInfo')
  const resolverSynced = resolverIsSynced(resolver, location)
  const resolvedTypeNotSubCat = resolver.getIn(['data', 'type']) !== RESOLVER_TYPE_SUBCATEGORY
  if (
    location.pathname !== jumbotronState.get('path')
    && !jumbotronState.get('placeholderExists')
  ) {
    setJumbotronDataPlaceholder(storeKey)
    setCommentsVisible(false)
    return
  }
  if (!resolverSynced) {
    return
  }

  if (!jumbotronSynced && !jumbotronState.get('processing')) {
    getJumbotronData(
      storeKey,
      resolvedId,
      resolver.getIn(['data', 'type']),
      location.pathname,
      auth,
      user,
    )
    return
  }

  // Hydrate Tiles userInfo on initial page load
  if (
    auth.get('jwt')
    && resolvedTypeNotSubCat
    && jumbotronSynced
    && !jumbotronState.get('processing')
    && !userInfoSynced
    && !jumbotronState.get('userInfoProcessing')
  ) {
    getJumbotronDataUserInfo(storeKey, [jumbotronState.get('id')], auth)
  }
}

class Jumbotron extends Component {
  componentDidMount () {
    updateData(this.props)
  }

  componentDidUpdate () {
    if (!process.env.BROWSER) {
      return
    }
    updateData(this.props)
  }

  componentWillUnmount () {
    const { setCommentsVisible } = this.props
    setCommentsVisible(false)
  }

  render () {
    const { props } = this
    const {
      storeKey,
      jumbotron,
      auth,
      setOverlayDialogVisible,
      history,
    } = props
    const data = jumbotron.getIn([storeKey, 'data'], Map())

    switch (data.getIn(['type', 'content'])) {
      case TYPE_CONTENT_SUBCATEGORY:
        return (
          <JumbotronSubcategory
            auth={auth}
            title={data.get('title', '')}
            description={data.get('description', '')}
            heroImage={data.get('heroImage')}
            setOverlayDialogVisible={setOverlayDialogVisible}
            id={data.get('id')}
            history={history}
          />
        )
      default:
        return <BannerPlaceholder />
    }
  }
}

Jumbotron.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  jumbotron: ImmutablePropTypes.map.isRequired,
  storeKey: PropTypes.string.isRequired,
  resolver: ImmutablePropTypes.map.isRequired,
  getJumbotronData: PropTypes.func.isRequired,
  getJumbotronDataUserInfo: PropTypes.func.isRequired,
  setJumbotronDataPlaceholder: PropTypes.func.isRequired,
  resetJumbotronData: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  setOverlayDialogVisible: PropTypes.func,
  setCommentsVisible: PropTypes.func.isRequired,
  history: PropTypes.object,
}

// eslint-disable-next-line import/no-mutable-exports
let connectedJumbotron = connectRedux(
  (state) => ({
    user: state.user,
    auth: state.auth,
    resolver: state.resolver,
    jumbotron: state.jumbotron,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      getJumbotronData: actions.jumbotron.getJumbotronData,
      getJumbotronDataUserInfo: actions.jumbotron.getJumbotronDataUserInfo,
      setJumbotronDataPlaceholder:
        actions.jumbotron.setJumbotronDataPlaceholder,
      resetJumbotronData: actions.jumbotron.resetJumbotronData,
      setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      setCommentsVisible: actions.comments.setCommentsVisible,
    }
  },
)(Jumbotron)
connectedJumbotron = connectLanguage({ createOnLanguageChange })(
  connectedJumbotron,
)

export default connectedJumbotron
